import dayjs from "dayjs";
import "dayjs/locale/bg";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.locale("bg");

export const fmtDate = (v) => v ? dayjs.utc(v).tz("Europe/Sofia").format("DD.MM.YYYY") : "—";
export const fmtDateTime = (v) => v ? dayjs.utc(v).tz("Europe/Sofia").format("DD.MM.YYYY HH:mm") : "—";
export const fmtMoney = (v, currency = "EUR") => {
  const n = Number(v || 0);
  try {
    return new Intl.NumberFormat("bg-BG", { style: "currency", currency }).format(n);
  } catch {
    return `${n.toFixed(2)} ${currency}`;
  }
};
export const fmtBytes = (b) => {
  if (!b) return "0 B";
  const kb = b / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb/1024).toFixed(1)} MB`;
};
